import { AlphaKBoxIcon } from './AlphaKBoxIcon';

/**
 * author: GreenTurtwig
 * id EF778205-36FD-4C55-BDFB-0373983C95D4
 * name alpha-k-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-k-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetKBoxIcon = AlphaKBoxIcon;
export default AlphabetKBoxIcon